export default __webpack_public_path__ + "static/media/home_ghibli_totoro_father.7b694a63.jpg";